import React from 'react';
import { Box, Typography, Container, Accordion, AccordionSummary, AccordionDetails, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqItems = [
    { 
        question: "How is the AI assistant different from a normal chatbot?", 
        answer: "Our AI is trained to provide emotional grounding and guidance based on community-sourced knowledge, and directly connects you with vetted, local resources." 
    },
    { 
        question: "Is my personal information and chat history private?", 
        answer: "Yes. We use advanced encryption. Your identity in public rooms is pseudonymized, and resource searches are anonymized." 
    },
    { 
        question: "How can I suggest a new resource or topic category?", 
        answer: "You can submit suggestions through the dedicated 'Feedback' link in the header or message an admin in any public chat room. We review all submissions weekly." 
    },
    { 
        question: "What does 'Recommended Fit Score' mean?", 
        answer: "The fit score ranks resources based on proximity to your known location, community reviews, and AI analysis of the resource's mission versus your stated needs." 
    },
];

export const FAQ = () => {
    const theme = useTheme();

    return (
        <Box id="faq" sx={{ py: 6, bgcolor: theme.palette.background.default }}>
            <Container maxWidth="md">
                <Typography 
                    variant="h3" 
                    align="center" 
                    sx={{ mb: 5, fontWeight: 700, color: theme.palette.primary.dark }}
                >
                    Frequently Asked Questions
                </Typography>
                
                {faqItems.map((item, index) => (
                    <Accordion 
                        key={index} 
                        sx={{ mb: 1, borderRadius: 2, '&.MuiPaper-root': { boxShadow: 3 } }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon color="primary" />}
                            aria-controls={`panel${index}-content`}
                            id={`panel${index}-header`}
                        >
                            <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                {item.question}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography color="text.secondary">
                                {item.answer}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Container>
        </Box>
    );
};